import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { Auth } from 'aws-amplify';
import { DateTime } from 'luxon';
import { Subject } from 'rxjs';
import { RestrictIfService } from './shared/restrict/restrict-if.service';
import { AuthService } from './shared/services/auth.service';

@Component({
  selector: 'app-auth-o3',
  templateUrl: './auth-o3.component.html',
  styleUrls: ['./auth-o3.component.scss'],
})
export class AuthO3Component implements OnInit, OnDestroy {
  isAuthenticated = false;
  loading = true;
  navigating = false;
  signedIn = false;
  user: string = undefined;
  email: string = undefined;
  closePanels = false;
  destroy$ = new Subject();

  appVersion = 'APP_VERSION_PLACEHOLDER';
  appBuildNumber = 'APP_BUILD_NUMBER_PLACEHOLDER';
  appBuildTime = parseInt('APP_BUILD_TIME_PLACEHOLDER', 10) || 1584435059600;
  environment = '';
  appBuildDateString: string;

  constructor(
    public authService: AuthService,
    public restrictService: RestrictIfService,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    try {
      if (this.appVersion.startsWith('APP_')) {
        this.appVersion = 'DEV-BUILD';
      }
      if (this.appBuildNumber.startsWith('APP_')) {
        this.appBuildNumber = 'DEV';
      }
      const dateTime = DateTime.fromMillis(this.appBuildTime);
      this.appBuildDateString = dateTime.toLocaleString({
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: false,
      });
    } catch (e) {
      console.error('Failed to determine application version', e);
    }

    this.authService.onUserSession.subscribe((session) => {
      this.signedIn = session?.isValid();
      this.user =
        session?.isValid() && session.idToken.payload['cognito:username'];
      this.email = session?.isValid() && session.idToken.payload.email;
    });

  }

  async ngOnInit() {

    try {
      await Auth.currentAuthenticatedUser();
      this.isAuthenticated = true;
    } catch {
      this.isAuthenticated = false;
    }

  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

  async signOut() {
    this.isAuthenticated = false;
    sessionStorage.removeItem('redirectAfterLogin');
    this.authService.signOut();
    this.router.navigate(['/login']);
  }

  onLoaded() {
    this.loading = false;
    this.cdr.detectChanges();
  }


}
